import styles from './style.styl'
import { Big, Small, Tiny } from '../text'
import footerLogo from '../../assets/images/logos/footerLogo.jpg'
import { cc } from '../../utils'
import { FbIcon, IgIcon, LiIcon, PcIcon, TkIcon, TwIcon, YtIcon } from '../social'
import FooterForm from '../footer-form'

const Social = () => (
  <div className={styles.social}>
    <FbIcon />
    <TwIcon />
    <IgIcon />
    <YtIcon />
    <LiIcon />
    <TkIcon />
    <PcIcon />
  </div>
)

const FooterNew = () => {
  const scrollToApply = () => {
    const section = document.getElementById('apply')
    const { top } = section.getBoundingClientRect()
    window.scrollTo({ top: top + window.scrollY, behavior: 'smooth' })
  }

  return (
    <div className={styles.footer}>
      <div className={styles.footer1}>
        <Big dangerouslySetInnerHTML={{ __html: 'NEVER STOP <br /> LE<span class="alt">A</span>RN<span class="alt">I</span>NG' }} className={styles.infoTitle} />
        <Small className={styles.text}>
          Future London <span className='alt'>A</span>cademy is an executive school for creatives. <span className='alt'>I</span>n the last 11 years, we have helped 500+ companies learn the latest tools and approaches to branding, innovation, <span className='alt'>U</span>X and leadership.
        </Small>

        <Small dangerouslySetInnerHTML={{ __html: '<span class="alt">A</span>s seen on' }} className={cc('upper', styles.infoText)} />
        <div className={styles.images}>
          <img src={footerLogo} alt={'dezeen, its nice that, the economist'} className={styles.logo} />
        </div>
      </div>
      <div className={styles.footer2}>
        <Small
          dangerouslySetInnerHTML={{ __html: 'Jo<span class="alt">i</span>n o<span class="alt">u</span>r newsletter' }}
          className={cc('upper', styles.title, styles.titleLetterSpace)} />
        <Small className={styles.formText}>
          Get insights on Design Leadership, Strategy and Culture as well as updates about upcoming
          programmes in your inbox.
        </Small>
        <FooterForm />
      </div>
      <div className={styles.connectContainer}>
        <Small dangerouslySetInnerHTML={{ __html: 'Let’s connect' }}
          className={cc('upper', styles.title, styles.connectTitle)} />
        <div className={styles.connect}>
          <Small as={'a'} href={'https://futurelondonacademy.co.uk/en/journal/'} target={'_blank'}>Read
            our journal</Small>
          <Small as={'span'} onClick={scrollToApply}>Download Brochure</Small>
          <Small>Follow us</Small>
        </div>
        <Social />

        <div className={styles.copy}>
          <Tiny as={'p'}
            dangerouslySetInnerHTML={{ __html: 'F<span class="alt">u</span>t<span class="alt">u</span>re London <span class="alt">A</span>c<span class="alt">a</span>demy. ' }}
            className={'upper'} />
          <Tiny as={'p'}
            dangerouslySetInnerHTML={{ __html: '<span class="alt">A</span>ll rights reserved' }}
            className={styles.copyText} />
        </div>
      </div>
    </div>
  )
}

export default FooterNew



// WEBPACK FOOTER //
// ./components/footer-new/index.js